<template>
  <div
    :class="{ '-active': vehicle.id === currentVehicle.id }"
    class="vehicle"
    @click="toggleVehicle(vehicle.id)"
  >
    <div class="vehicle__img">
      <img :src="imageManager().picture(vehicle.thumbnail, 'mobile')" />
    </div>
    <div class="w-100">
      <div class="vehicle__label">
        <span class="e-aixam -card me-2" v-html="processVehicleLabel()"></span>
        <span v-if="displayLabel()">{{ vehicle.label }}</span>
      </div>
      <div class="vehicle__energy">{{ vehicle.motors[0].label }}</div>
      <div class="vehicle__price">
        {{
          getTranslation(488, {
            PRICE: formatPrice(vehicle.motors[0].installment),
            CURRENCY: currency,
          })
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { priceManager } from "@/services/price-manager";
import { vehicleManager } from "@/services/vehicle-manager";
import { useMainStore } from "@/store";
import { mapActions, mapState } from "pinia";
import { getTranslation } from "@/services/translation-manager";
import { imageManager } from "@/services/image-manager";

export default {
  name: "VehicleCardComponent",
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
    currentVehicle: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useMainStore, {
      currency: (store) => store.currency,
    }),
  },
  methods: {
    imageManager() {
      return imageManager;
    },
    formatPrice(price) {
      return priceManager.format(price);
    },

    displayLabel() {
      return (
        this.vehicle &&
        this.vehicle.vehicle_label &&
        !this.vehicle.vehicle_label.includes(this.vehicle.label)
      );
    },

    getTranslation(id, params = {}) {
      return getTranslation(id, params);
    },

    processVehicleLabel() {
      return vehicleManager.processLabel(this.vehicle.vehicle_label);
    },

    ...mapActions(useMainStore, ["toggleVehicle"]),
  },
};
</script>

<style lang="scss" scoped>
.vehicle {
  padding: 15px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.-active {
    background: $white;
    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
  }

  &__img {
    margin-bottom: 10px;

    img {
      width: 100%;
    }
  }

  &__label {
    text-transform: uppercase;
    font-size: 30px;
    font-weight: 500;
    line-height: 1;
    display: flex;
    flex-wrap: wrap;
  }

  &__energy {
    font-size: 16px;
  }

  &__price {
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
  }
}
</style>
